import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutEvent from "./components/AboutEvent";
import AboutFounder from "./components/AboutFounder";
import Benefits from "./components/Benefits";
import ConnectTo from "./components/ConnectTo";
import EventGallery from "./components/EventGallery";
import Origin from "./components/Origin";
import VisionMission from "./components/VisionMission";
import Footer from "./components/Footer";
import RegistrationForm from "./components/register/RegistrationForm";

// Scroll to top component
function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
}

function App() {
    return (
        <>
            <ScrollToTop />
            {/* Skip to main content link for screen readers */}
            <a
                href="#main-content"
                className="skip-link"
                style={{
                    position: "absolute",
                    top: "-40px",
                    left: "6px",
                    backgroundColor: "#2563eb",
                    color: "white",
                    padding: "8px 16px",
                    textDecoration: "none",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: "600",
                    zIndex: 1000,
                    transition: "top 0.3s",
                }}
                onFocus={(e) => {
                    e.target.style.top = "6px";
                }}
                onBlur={(e) => {
                    e.target.style.top = "-40px";
                }}
            >
                Skip to main content
            </a>
            <Header />
            <main id="main-content" role="main" tabIndex="-1">
                <Routes>
                    <Route
                        path="/"
                        element={
                            <>
                                <Hero />
                                <ConnectTo />
                                <AboutEvent />
                                <Benefits />
                                <AboutFounder />
                                <VisionMission />
                                <Origin />
                                <EventGallery />
                            </>
                        }
                    />
                    <Route path="/reg" element={<Navigate to="/" replace />} />{" "}
                    <Route
                        path="/registration"
                        element={<RegistrationForm />}
                    />
                </Routes>
            </main>
            <Footer />
        </>
    );
}

export default App;
